export class PPStation {
    address: string;
    band: string;
    callLetters: string;
    city: string;
    descriptiveName: string;
    digital: false;
    enterpriseMarketId: number;
    enterpriseStationId: number;
    fccId: string;
    format: string;
    frequency: string;
    id: string;
    market: string;
    marketId: string;
    marketingName: string;
    name: string;
    nexgenMarketUrl: string;
    nexgenStationId: number;
    primaryGenre: string;
    state: string;
    stationId: string;
    stationLogoUrl: string;
    timezone: string;
    websiteUrl: string;
    zip: number;
}

